

















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class DAGNode extends Vue {
  @Prop({ default: 1 }) readonly scale!: number;
  @Prop() readonly id!: number;
  @Prop() readonly x!: number;
  @Prop() readonly y!: number;

  get nodePositionAndScale() {
    return {
      top: this.y * this.scale + 'px',
      left: this.x * this.scale + 'px',
      transform: `scale(${this.scale})`,
    };
  }
}
